import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { bindActionCreators } from 'redux';
import { SubmissionError } from 'redux-form';
import LoadingProgress from '../components/LoadingProgress'

import { fetchDuplicatedSales } from '../actions/duplicatedsales';
import { fetchMachines } from '../actions/machines';
import { fetchCustomersName } from '../actions/customers';

import { renderInputField, renderSelectField } from '../utils/forms';

// Filtro de la vista de ventas duplicadas. Solo admin, así que a diferencia de SalesFilterForm
// se muestran siempre los desplegables de Cliente y Máquina. Los datos de esos desplegables son
// el estado compartido state.customers / state.machines (mismos que la vista de Ventas).
class DuplicatedSalesFilterForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      loading: false
    };

    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    this.props.fetchMachines();
    this.props.fetchCustomersName();
    this.load(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.load(nextProps);
  }

  load(props) {
    const { machines, customers } = props;

    if (!this.state.loaded && machines && customers) {
      this.setState({ loaded: true });
    }
  }

  submit(props) {
    this.setState({ loading: true });

    return this.props.fetchDuplicatedSales(
      props.Machine,
      props.Customer,
      props.StartDate,
      props.EndDate,
      props.DateField,
      props.SameAsOriginal
    ).then((response) => {
      this.setState({ loading: false });

      if (response.error) {
        throw new SubmissionError({
          _error: response.error.message,
          ...response.error.fields,
        });
      }

      return response;
    }).catch((error) => {
      this.setState({ loading: false });
      throw error;
    });
  }

  render() {
    const { loaded } = this.state;
    const {
      error,
      submitting,
      handleSubmit,
      machines,
      customers,
      formValues
    } = this.props;

    if (!loaded) {
      return <LoadingProgress />
    }

    const selectedCustomer = formValues.Customer;
    const filteredMachines = machines.filter(
      (machine) =>
        !selectedCustomer || (machine.Customer && machine.Customer._id === selectedCustomer)
    );

    return (
      <form onSubmit={handleSubmit(this.submit)} className="mb-3">
        {submitting ? (<div className="row"></div>) : (
          <div className="row">
            <div className="col">
              <Field
                name="Customer"
                component={renderSelectField}
                label="Cliente"
              >
                <option value="">Todos</option>
                {customers &&
                  customers
                    .filter((customer) => customer.Type === 'GENERAL' || customer.Type === 'LICENCIA_BASICA' || customer.Type === 'LICENCIA_PRO')
                    .sort((a, b) => a.Fullname.localeCompare(b.Fullname))
                    .map((customer) => (
                      <option value={customer._id} key={customer._id}>
                        {customer.Fullname}
                      </option>
                    ))}
              </Field>
            </div>
            <div className="col">
              <Field
                name="Machine"
                component={renderSelectField}
                label="Máquina"
              >
                <option value="">Todas</option>
                {filteredMachines.map((machine) => (
                  <option value={machine._id} key={machine._id}>
                    {machine.Serial} - {machine.Customer?.Fullname || 'None'}
                  </option>
                ))}
              </Field>
            </div>
            <div className="col">
              <Field
                name="SameAsOriginal"
                component={renderSelectField}
                label="Tipo"
              >
                <option value="">Todas</option>
                <option value="false">Ventas perdidas</option>
                <option value="true">Réplicas</option>
              </Field>
            </div>
            <div className="col">
              <Field
                name="StartDate"
                component={renderInputField}
                type="date"
                label="Fecha inicio"
              />
            </div>
            <div className="col">
              <Field
                name="EndDate"
                component={renderInputField}
                type="date"
                label="Fecha fin"
              />
            </div>
            <div className="col">
              <Field
                name="DateField"
                component={renderSelectField}
                label="Filtrar por"
              >
                <option value="detectedAt">Fecha Detección</option>
                <option value="TimeStamp">Fecha Compra</option>
                <option value="createdAt">Fecha Registro</option>
              </Field>
            </div>
          </div>
        )}
        <div className="form-row">
          {error && <div className="alert alert-danger">{error}</div>}
        </div>
        <div className="form-row justify-content-center mt-2">
          {this.state.loading ? (
            <div className="loading-wheel"></div>
          ) : (
            <button className="btn bg-vw-dark text-white mr-2" type="submit">
              <i className="fas fa-sync mr-1"></i>Actualizar
            </button>
          )}
        </div>
      </form>
    );
  }
}

DuplicatedSalesFilterForm = reduxForm({
  form: 'DuplicatedSalesFilterForm',
})(DuplicatedSalesFilterForm);

const selector = formValueSelector('DuplicatedSalesFilterForm');

// Rango por defecto: últimos 7 días (debe coincidir con el fetch inicial de DuplicatedSalesView).
const defaultStart = (() => {
  const d = new Date();
  d.setDate(d.getDate() - 7);
  return d.toISOString().substring(0, 10);
})();
const defaultEnd = new Date().toISOString().substring(0, 10);

const mapStateToProps = (state) => ({
  machines: state.machines.machines,
  customers: state.customers.customers,
  duplicatedSales: state.duplicatedSales,
  role: state.auth.role,
  type: state.auth.type,
  initialValues: {
    Machine: '',
    Customer: '',
    SameAsOriginal: '',
    StartDate: defaultStart,
    EndDate: defaultEnd,
    DateField: 'detectedAt',
  },
  formValues: {
    Machine: selector(state, 'Machine'),
    Customer: selector(state, 'Customer'),
    SameAsOriginal: selector(state, 'SameAsOriginal'),
    StartDate: selector(state, 'StartDate'),
    EndDate: selector(state, 'EndDate'),
    DateField: selector(state, 'DateField'),
  },
});

const mapDispatchToProps = (dispatch) => ({
  fetchDuplicatedSales: bindActionCreators(fetchDuplicatedSales, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
  fetchCustomersName: bindActionCreators(fetchCustomersName, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DuplicatedSalesFilterForm);
